export const SET_ACCOUNT = 'account/account-set';
